// ============================================
// INFRASTRUCTURE - Notificaciones Repository
// ============================================

import { axiosClient } from './axios-client';
import type { Changelog } from '../../domain/entities';

export const notificacionesRepository = {
  /**
   * Obtener los anuncios/changelog activos que aún no han sido vistos
   * por el usuario autenticado.
   */
  async getChangelogActivas(): Promise<Changelog[]> {
    const { data } = await axiosClient.get<Changelog[]>(
      '/v1/notificaciones/changelog/activas'
    );
    return data;
  },

  /**
   * Marcar una notificación como vista por el usuario autenticado.
   * Se llama en "fire and forget" desde el hook.
   */
  async marcarVisto(changelogId: number): Promise<void> {
    await axiosClient.post(`/v1/notificaciones/changelog/${changelogId}/visto`);
  },
};
